import React, { Fragment, useState } from 'react';
import { ISideBar, SidebarOption } from './interfaces';
import { Box, CustomTheme, Drawer, List, useTheme } from '@mui/material';
import { MenuItem } from './components/MenuItem';
import { SubMenu } from './components/SubMenu';
import { useLocation, useNavigate } from 'react-router';
import { BottomMenu } from './components/BottomMenu';
import { useTranslation } from 'react-i18next';
import { getActiveMenuOption, menuOptions } from './helpers';

export const SideBar: React.FC<ISideBar> = ({
  isMobileDevice,
  onClose,
  showMobileMenu = false,
}): JSX.Element => {
  const { t } = useTranslation();
  const theme = useTheme<CustomTheme>();

  const navigate = useNavigate();
  const location = useLocation();

  const [actibeMainMenuItem, setActibeMainMenuItem] = useState<string | null>(
    null
  );

  const activeMenuOption: string | undefined = getActiveMenuOption(
    location.pathname
  );

  const navigateTo = (mainMenuOption: SidebarOption) => {
    setActibeMainMenuItem(mainMenuOption.key);
    navigate(mainMenuOption.link || '/');
    onClose();
  };

  const isMenuOptionActive = (menuOption: SidebarOption): boolean => {
    if (location.pathname === menuOption.link) {
      return true;
    }

    for (const subItem of menuOption.subItems || []) {
      if (location.pathname === subItem.link) {
        return true;
      }
    }

    for (const subItem of menuOption.subItems || []) {
      if (location.pathname.startsWith(subItem.link)) {
        return true;
      }
    }

    return false;
  };

  return (
    <Drawer
      variant={isMobileDevice ? 'temporary' : 'permanent'}
      open={showMobileMenu}
      onClose={onClose}
      sx={{
        '& .MuiDrawer-paper': {
          backgroundColor: `${theme.portal.sidebar.background}`,
        },
      }}
    >
      <Box
        sx={{
          width: `${theme.portal.sidebar.width}`,
          p: '15px',
          boxSizing: 'border-box',
          display: 'flex',
          flex: 1,
          flexDirection: 'column',
        }}
      >
        <Box
          sx={{
            width: '150px',
          }}
        >
          <img src="/logos/logo-canazados.png" width="100%" />
        </Box>

        <List
          sx={{
            mt: '20px',
          }}
        >
          {menuOptions.map((option, index) => {
            return (
              <Fragment key={index}>
                <MenuItem
                  key={option.key}
                  label={option.label}
                  hint={option.hint}
                  active={option.link ? isMenuOptionActive(option) : false}
                  onClick={() => navigateTo(option)}
                  icon={option.icon}
                />
                {option.subItems && (
                  <SubMenu
                    show={option.link ? isMenuOptionActive(option) : false}
                    menuOptions={option.subItems}
                  />
                )}
              </Fragment>
            );
          })}
        </List>
        <Box
          sx={{
            marginTop: 'auto',
          }}
        >
          <BottomMenu />
        </Box>
      </Box>
    </Drawer>
  );
};
